import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const Parallelogram = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="82" viewBox="0 0 82 75" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M55.9862 74.0412H0.767975L26.0438 0.937241H81.263L55.9862 74.0412Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
